import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProcessingActivitydetailPageRoutingModule } from './processing-activitydetail-routing.module';

import { ProcessingActivitydetailPage } from './processing-activitydetail.page';
import { SharedModule } from '../../shared/shared.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgxPopperModule } from 'ngx-popper';
import { NgxDatatableModule } from '@siemens/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    NgxPopperModule,
    NgxDatatableModule,
    NgxSmartModalModule,
    ProcessingActivitydetailPageRoutingModule
  ],
  declarations: [ProcessingActivitydetailPage]
})
export class ProcessingActivitydetailPageModule {}
